import React from 'react';
import PropTypes from 'prop-types';
import localStyles from './styles.less';
import ImageUpload from '../../InlineEditorWizard/ImageUpload';
import CourseSvg from '../imagesSvg/courseSvg';
import WizardInput from '../Input';

const CourseImageSelect = ({ t, image, setValue, imageButtonText }) => (
  <>
    <WizardInput title={t('course.create.wizard.step6_2')} hint={t('wizard.hint.image')}>
      <div className={localStyles.coursePhoto}>
        {image ? <img src={image} alt="courseImage" /> : <CourseSvg />}
      </div>
      <div className={localStyles.coursePhotoWraper}>
        <ImageUpload
          uploadHandler={url => {
            setValue(url, 'courseImage');
          }}
          type="course"
          folder="course"
          className={localStyles.coursePhotoButton}
          containerClassName="editCourseImage"
          text={imageButtonText}
          name="wizard_courseImg_upload"
        />
      </div>
    </WizardInput>
  </>
);

CourseImageSelect.propTypes = {
  image: PropTypes.string,
  imageButtonText: PropTypes.string,
  setValue: PropTypes.func,
  t: PropTypes.func,
};

CourseImageSelect.defaultProps = {
  image: '',
  setValue: () => {},
  imageButtonText: 'upload',
  t: () => {},
};

export default CourseImageSelect;
